'use strict';

angular.module('mean.builders').controller('BuilderReviewController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidBuilderReview', 'CompanyFactors', '$location', 'tradeCodeService', 'taskTotalsService', 'TradeBids', 'bidService', 'builderService', 'bidRequestEditService', 'TradeItems', 'userService',
  function($scope, MeanUser, Global, Bids, $filter, $sce, toaster, NotifyService, BidBuilderReview, CompanyFactors, $location, tradeCodeService, taskTotalsService, TradeBids, bidService, builderService, bidRequestEditService, TradeItems, userService) {
    $scope.global = Global;

    $scope.expanded_table = 'true';
    $scope.bid_total_labor = 0;
    $scope.bid_total_materials = 0;
    $scope.bid_total_equipment = 0;
    $scope.bid_total = 0;
    $scope.bid_general_liability = 0;
    $scope.trade_totals = [];
    $scope.current_trade_selection = {}
    $scope.current_trade_selection.trade = 'Total';
    $scope.bid_tasks = [];
    $scope.showPlanDetails = -1;
    $scope.showTaskDetails = -1;
    $scope.showExpandableDetails = -1;
    $scope.showSubtaskDetails = -1;
    $scope.showSubtaskDetails = -1;
    $scope.open_plan_details = false;
    $scope.open_task_details = false;
    $scope.open_rates_details = false;
    $scope.total_quantity = 0;
    $scope.tradeItems = [];
    $scope.main_account_id = null;

    $scope.user = MeanUser.user;

    $scope.allTradesSelected = false;
    $scope.currentTradeSelected = false;

    $scope.materials = [];
    $scope.equipment = [];

    $scope.sub_total_bidding_trades = [];

    $scope.MaterialTotal = 0;
    $scope.EquipmentTotal = 0;

    $scope.sortType = ['task', 'name', 'note'];
    $scope.sortReverse = false;
    $scope.filtered_menu_items = ['Specs', 'Materials', 'Total Materials'];

    $scope.global_task_list = [];
    $scope.is_builder = builderService.isBuilder($scope.user.username);

    userService.getMainAccountId($scope.user.username).then(function(id) {
        $scope.main_account_id = id;
    });

    var data = [];

    $scope.toggleTableColumns = function() {
        if($scope.expanded_table === 'true') {
            $scope.expanded_table = 'false';
        } else {
            $scope.expanded_table = 'true';
        }
    };

    $scope.filteredMenuItem = function(item) {
        return ($scope.filtered_menu_items.indexOf(item) !== -1);
    };

    $scope.init = function() {
        $scope.expanded_table = 'false';
        $scope.bid = BidBuilderReview.get();

        $scope.selectedTrade = '';

        if(!$scope.bid || !$scope.bid._id){
            $location.path('/');
            return;
        }

        Bids.query({'_id': $scope.bid._id}, function(bids) {
            if(bids.length !== 1) {
                toaster.pop('error', 'Database', 'Could not find the bid');
                return;
            }

            $scope.bid = bids[0];

            $scope.trades = [];

            TradeItems.query({'bid_id': $scope.bid._id}, function(tradeItems) {
                _.each(tradeItems, function(tradeItem) {
                    $scope.tradeItems.push(tradeItem);
                });

                var temp_bids = [];
                for(var i=0; i<$scope.bid.bidding_trades.length; i++) {
                    $scope.bid.bidding_trades[i].remove = false;
                    temp_bids.push($scope.bid.bidding_trades[i])

                    if($scope.bid.bidding_trades[i].revisions.length) {
                        var base_bid = angular.copy($scope.bid.bidding_trades[i]);
                        for(var j=0; j<$scope.bid.bidding_trades[i].revisions.length; j++) {
                            base_bid.bid = 
                                angular.copy($scope.bid.bidding_trades[i].revisions[j].bid);
                            base_bid.costs = 
                                angular.copy($scope.bid.bidding_trades[i].revisions[j].costs);
                            base_bid.overrides = 
                                angular.copy($scope.bid.bidding_trades[i].revisions[j].overrides);

                            if($scope.bid.bidding_trades[i].revisions[j].extra_liability) {
                                base_bid.extra_liability = 
                                    angular.copy($scope.bid.bidding_trades[i].revisions[j].extra_liability);
                            } else {
                                //compute extra liability here for trade bids that do not have it
                                console.log('compute here');
                            }

                            if($scope.bid.bidding_trades[i].revisions[j].number === 1) {
                                base_bid.name = 'Original'
                            } else {
                                base_bid.name = 'Rev ' + 
                                    Number($scope.bid.bidding_trades[i].revisions[j].number - 1) + '';
                            }

                            base_bid.remove = true;
                            temp_bids.push(angular.copy(base_bid));
                        }
                    }
                }

                $scope.bid.bidding_trades = temp_bids;

                //build a selector of trades
                for(var i=0; i<$scope.bid.bidding_trades.length; i++) {
                    var bid = $scope.bid.bidding_trades[i];
                    if(bid.submitted === 'true' && ($scope.trades.indexOf(bid.trade) === -1))
                      $scope.trades.push(bid.trade);
                }

                if($scope.trades.length > 0)
                  $scope.changeTrade($scope.trades[0]);

                $scope.specs = [];

                $scope.bid_menu = [];
                $scope.plan_total_items = [];

                _.each($scope.bid.plan_codes, function(item) {
                    $scope.bid_menu.push({
                        item: item.code
                    });

                    $scope.plan_total_items.push({
                        item: item.code,
                        quantity: item.quantity
                    });
                });

                $scope.trade_totals = [];
                $scope.bid_menu.push({
                    item: 'Specs'
                });
                $scope.bid_menu.push({
                    item: 'Materials'
                });
                $scope.bid_menu.push({
                    item: 'Total Materials'
                });

                $scope.current_plan = $scope.bid_menu[0];

                $scope.bid.bidding_trades.forEach(function(bid, idx) {

                    var current_bid_trade = bid.trade;
                    $scope.trade_totals.push({
                        name: bid.name,
                        trade: bid.trade,
                        trade_code: userService.getTradeCode(bid.username),
                        company_code: userService.getCompanyCode(bid.username),
                        accepted: bid.accepted,
                        overrides: bid.overrides,
                        extra_liability: bid.extra_liability
                    });
                    //$scope.trade_totals[idx].plan_totals = [];

                    $scope.my_bid_trade = $scope.getTradeCode(current_bid_trade);
                    $scope.bid_menu.forEach(function(menu, mdx) {
                       if(menu.item === 'Specs') return;
                       if(menu.item === 'Materials') return;
                       if(menu.item === 'Total Materials') return;

                        var bid_tasks = [];
                        var tasks = $filter('filter')(bid.task_list, {'trade': $scope.my_bid_trade}, true);

                        for(var ii=0; ii<tasks.length; ii++) {
                            tasks[ii].plan = menu.item;
                            tasks[ii].trade_name = bid.name;

                            var inlist = $filter('filter')(bid.bid, {'task_id': tasks[ii]._id, 'plan_code': menu.item}, true);

                            if(inlist.length === 1) {
                                for(var j=0; j<inlist[0].subtasks.length; j++) {
                                    var sub = $filter('filter')(tasks[ii].subtasks, {'_id': inlist[0].subtasks[j].task_id}, true);

                                    if(sub.length === 1) {
                                        sub[0].trade_name = bid.name;
                                        sub[0].quantity = inlist[0].subtasks[j].quantity;
                                        sub[0].bid_hours = inlist[0].subtasks[j].bid_hours;
                                        sub[0].labor = inlist[0].subtasks[j].labor;
                                    }

                                    if(sub[0]) {
                                        for(var k=0; k<sub[0].materials.length; k++) {
                                            var mat = $filter('filter')(inlist[0].subtasks[j].materials, 
                                                {'material_id': sub[0].materials[k]._id}, true);

                                            if(mat.length === 1) {
                                                sub[0].materials[k].trade_name = bid.name;
                                                sub[0].materials[k].quantity = mat[0].quantity;
                                                sub[0].materials[k].price_per_order = mat[0].price_per_order;
                                                sub[0].materials[k].delivery_price = mat[0].delivery_price;
                                            } else {
                                                sub[0].materials[k].trade_name = bid.name;
                                                sub[0].materials[k].quantity = 0;
                                                sub[0].materials[k].price_per_order = 0;
                                                sub[0].materials[k].delivery_price = 0;
                                            }
                                        }

                                        for(var k=0; k<sub[0].equipment.length; k++) {
                                            var eq = $filter('filter')(inlist[0].subtasks[j].equipment, 
                                                {'equipment_id': sub[0].equipment[k]._id}, true);

                                            if(eq.length === 1) {
                                                sub[0].equipment[k].trade_name = bid.name;
                                                sub[0].equipment[k].quantity = eq[0].quantity;
                                                sub[0].equipment[k].price_per_order = eq[0].price_per_order;
                                                sub[0].equipment[k].delivery_price = eq[0].delivery_price;
                                            } else {
                                                sub[0].equipment[k].trade_name = bid.name;
                                                sub[0].equipment[k].quantity = 0;
                                                sub[0].equipment[k].price_per_order = 0;
                                                sub[0].equipment[k].delivery_price = 0;
                                            }
                                        }
                                    } else {
                                        console.log('this is not expected')
                                    }
                                }
                            } else {
                                for(var j=0; j<tasks[ii].subtasks.length; j++) {
                                    tasks[ii].subtasks[j].trade_name = bid.name;
                                    tasks[ii].subtasks[j].quantity = 0;
                                    tasks[ii].subtasks[j].bid_hours = 0;
                                    tasks[ii].subtasks[j].labor = 0;

                                    for(var k=0; k<tasks[ii].subtasks[j].materials.length; k++) {
                                        tasks[ii].subtasks[j].materials[k].trade_name = bid.name;
                                        tasks[ii].subtasks[j].materials[k].quantity = 0;
                                        tasks[ii].subtasks[j].materials[k].price_per_order = 0;
                                        tasks[ii].subtasks[j].materials[k].delivery_price = 0;
                                    }

                                    for(var k=0; k<tasks[ii].subtasks[j].equipment.length; k++) {
                                        tasks[ii].subtasks[j].equipment[k].trade_name = bid.name;
                                        tasks[ii].subtasks[j].equipment[k].quantity = 0;
                                        tasks[ii].subtasks[j].equipment[k].price_per_order = 0;
                                        tasks[ii].subtasks[j].equipment[k].delivery_price = 0;
                                    }
                                }
                            }

                            bid_tasks.push(angular.copy(tasks[ii]));
                        }

                        $scope.applayCalculations(bid_tasks, bid.name);

                        if(!$scope.trade_totals[idx].plan_totals)
                          $scope.trade_totals[idx].plan_totals = [];

                        $scope.trade_totals[idx].plan_totals.push(bid_tasks);
                        $scope.trade_totals[idx].plan_totals[mdx].plan_code = menu.item;
                    });
                });

                $scope.calculateTotals($scope.trade_totals);
                $scope.plan_details = $scope.transformTotalsArray($scope.totals);
                if($scope.trades.length > 0)
                  $scope.updateQuantity(0);

                _.each($scope.tradeItems, function(tradeItem) {
                    _.each($scope.plan_details, function(plans) {
                        var plan = $filter('filter')(plans, {
                            'trade_code': tradeItem.trade_code, 
                            'company_code': tradeItem.company_code }, true);

                        if(plan.length === 1) {
                            plan = plan[0];
                            if(!tradeItem.crew_rate) {
                                plan.bid_avg_crew_rate = 'N/A';
                                _.each(plan.tasks, function(task) {
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.average_crew_pay = 'N/A';
                                    });
                                });
                            }
                            if(!tradeItem.equipment_costs) {
                                plan.bid_total_equipment = 'N/A';
                                _.each(plan.tasks, function(task) {
                                    task.equipment_subtotal = 'N/A';
                                    task.equipment_dev_subtotal = 'N/A';
                                    task.total_equipment = 'N/A';
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.equipment_total = 'N/A';
                                        subtask.equipment_subtotal = 'N/A';
                                        subtask.equipment_dev_subtotal = 'N/A';
                                    });
                                });
                            }
                            if(!tradeItem.hours_allowed) {
                                plan.bid_total_hours_allowed = 'N/A';
                                _.each(plan.tasks, function(task) {
                                    task.hours_allowed_subtotal = 'N/A';
                                    task.total_hours_allowed = 'N/A';
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.hours_allowed = 'N/A';
                                    });
                                });
                            }
                            if(!tradeItem.labor_costs) {
                                plan.bid_direct_labor = 'N/A';
                                plan.bid_total_labor = 'N/A';
                                _.each(plan.tasks, function(task) {
                                    task.current_net_pay_subtotal = 'N/A';
                                    task.total_labor = 'N/A';
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.current_net_pay = 'N/A';
                                        subtask.labor = 'N/A';
                                    });
                                });
                            }
                            if(!tradeItem.liability) {
                                plan.bid_general_liability = 'N/A';
                                _.each(plan.tasks, function(task) {
                                    task.bid_general_liability = 'N/A';
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.general_liability = 'N/A';
                                    });
                                });
                            }
                            if(!tradeItem.markup) {
                                plan.bid_mark_up = 'N/A';
                                _.each(plan.tasks, function(task) {
                                    task.bid_mark_up = 'N/A';
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.bid_mark_up = 'N/A';
                                    });
                                });
                            }
                            if(!tradeItem.material_costs) {
                                plan.bid_total_materials = 'N/A';
                                _.each(plan.tasks, function(task) {
                                    task.materials_subtotal = 'N/A';
                                    task.materials_dev_subtotal = 'N/A';
                                    task.total_materials = 'N/A';
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.material_total = 'N/A';
                                        subtask.materials_subtotal = 'N/A';
                                        subtask.materials_dev_subtotal = 'N/A';
                                    });
                                });
                            }
                            if(!tradeItem.trade_rates) {

                            }
                            if(!tradeItem.quantity) {
                                _.each(plan.tasks, function(task) {
                                    _.each(task.subtasks, function(subtask) {
                                        subtask.quantity = 'N/A';
                                        _.each(subtask.materials, function(mat) {
                                            mat.quantity = 'N/A';
                                            mat.quantity_allowed = 'N/A';
                                        });
                                        _.each(subtask.equipment, function(eq) {
                                            eq.quantity = 'N/A';
                                            eq.quantity_allowed = 'N/A';
                                        });
                                    });
                                });
                            }
                        } else if(tradeItems.length > 1) {
                            toaster.pop('error', 'Trade Items Error', 'Contact Admin');
                            return;
                        }
                    });

                    var tasks = $filter('filter')($scope.global_task_list, {
                        'trade_code': tradeItem.trade_code, 
                        'company_code': tradeItem.company_code }, true);
                    _.each(tasks, function(task) {
                        _.each(task.values, function(value) {
                            if(!tradeItem.crew_rate) {
                                value.average_crew_pay = 'N/A';
                                _.each(value.subtasks, function(subtask) {
                                    subtask.crew_rate = 'N/A';
                                });
                            }
                            if(!tradeItem.equipment_costs) {
                                value.equipment_subtotal = 'N/A';
                                value.equipment_dev_subtotal = 'N/A';
                                value.total_equipment = 'N/A';
                                _.each(value.subtasks, function(subtask) {
                                    subtask.equipment_subtotal = 'N/A';
                                    subtask.equipment_dev_subtotal = 'N/A';
                                    subtask.equipment_total = 'N/A';
                                });
                            }
                            if(!tradeItem.hours_allowed) {
                                value.total_hours_allowed = 'N/A';
                                _.each(value.subtasks, function(subtask) {
                                    subtask.hours_allowed = 'N/A';
                                });
                            }
                            if(!tradeItem.labor_costs) {
                                value.total_labor = 'N/A';
                                _.each(value.subtasks, function(subtask) {
                                    subtask.labor = 'N/A';
                                });
                            }
                            if(!tradeItem.liability) {
                                value.bid_general_liability = 'N/A';
                                _.each(value.subtasks, function(subtask) {
                                    subtask.general_liability = 'N/A';
                                });
                            }
                            if(!tradeItem.markup) {
                                value.bid_mark_up = 'N/A';
                                _.each(value.subtasks, function(subtask) {
                                    subtask.bid_mark_up = 'N/A';
                                });
                            }
                            if(!tradeItem.material_costs) {
                                value.materials_subtotal = 'N/A';
                                value.materials_dev_subtotal = 'N/A';
                                value.total_materials = 'N/A';
                                _.each(value.subtasks, function(subtask) {
                                    subtask.materials_subtotal = 'N/A';
                                    subtask.materials_dev_subtotal = 'N/A';
                                    subtask.material_total = 'N/A';
                                });
                            }
                            if(!tradeItem.trade_rates) {

                            }
                            if(!tradeItem.quantity) {
                                _.each(value.subtasks, function(subtask) {
                                    subtask.quantity = 'N/A';
                                    _.each(subtask.materials, function(mat) {
                                        mat.quantity = 'N/A';
                                        mat.quantity_allowed = 'N/A';
                                    });
                                    _.each(subtask.equipment, function(eq) {
                                        eq.quantity = 'N/A';
                                        eq.quantity_allowed = 'N/A';
                                    });
                                });
                            }
                        });
                    });
                });
            });
        });
    };

    $scope.shouldDisplayItem = function(item, type) {
        if(!item) return;

        if(!item.trade_code || !item.company_code) {
            console.log('did not have trade or company code set for...');
            console.log(item);
            return;
        }
        var display = $filter('filter')($scope.tradeItems, {
            'trade_code': item.trade_code, 
            'company_code': item.company_code }, true);

        if(display.length === 0) return true;

        if(type === 'hours_allowed') {
            return display[0].hours_allowed;
        }

        if(type === 'crew_rate') {
            return display[0].crew_rate;
        }

        if(type === 'labor_costs') {
            return display[0].labor_costs;
        }

        if(type === 'liability') {
            return display[0].liability;
        }

        if(type === 'markup') {
            return display[0].markup;
        }

        if(type === 'material_costs') {
            return display[0].material_costs;
        }

        if(type === 'trade_rates') {
            return display[0].trade_rates;
        }

        if(type === 'quantity') {
            return display[0].quantity;
        }
        return true;
    };

    $scope.isAccepted = function(name) {
        var result = $filter('filter')($scope.bid.bidding_trades, {'name': name}, true);

        if(result.length === 1)
          return result[0].accepted;
        else
          return false;
    };

    $scope.filterTrade = function(item) {
        if(item === 'Total') return true;
        if(item === 'Total Materials') return true;
        if(item === 'Total Equipment') return true;
        if($scope.selectedTrade === '') return true;

        var inlist = $filter('filter')($scope.bid.bidding_trades, {'name': item})

        return inlist[0].trade === $scope.selectedTrade;
    }

    $scope.changeTrade = function(selectedTrade) {
        //$scope.selectedTrade = selectedTrade;
        $scope.selectedTrade = selectedTrade;
        $scope.bidding_trades = [];
        $scope.sub_bidding_trades = [];
        $scope.bidding_trades.push('Total');
        //$scope.bid.bidding_trades.forEach(function(bid) {
        for(var i=0; i<$scope.bid.bidding_trades.length; i++) {
            var bid = $scope.bid.bidding_trades[i];
            if(bid.trade === $scope.selectedTrade) {
                $scope.bidding_trades.push(bid.name);
                $scope.sub_bidding_trades.push(bid.name);
            }
        }

        $scope.current_trade_selection = {};
        $scope.current_trade_selection.trade = 'Total';

        $scope.checkCurrentTradeSelected();

        if(selectedTrade) {
            var inlist = $filter('filter')($scope.bid.bidding_trades, {'trade': selectedTrade}, true)[0];
            $scope.selectedTradeName = inlist.trade;
        } else
          $scope.selectedTradeName = $scope.selectedTrade = '';

        $scope.updateQuantity(0);
    };

    $scope.materialsPage = function(trade) {
        var bid_tasks = [];

        if(!$scope.bid || !$scope.bid._id){
            return;
        }

        bid_tasks = $filter('filter')($scope.bid.bidding_trades[$scope.current_bid_index].task_list, 
            {'trade': $scope.getTradeCode($scope.bid.bidding_trades[$scope.current_bid_index].trade)}, true);
    };

    $scope.totals = [];
    $scope.matrix_totals = [];

    $scope.calculateTotals = function(trades) {
        //step through each trade
        trades.forEach(function(trade, index) {
            var plan_total = 0;
            trade.plan_totals.forEach(function(plan, idx) {
                var inlist = $filter('filter')(trade.overrides, 
                    {'plan_code': plan.plan_code}, true);

                if(inlist.length === 1) {
                    //so...we have an override here and need to adjust
                    //the tasks that make up this plan to remove the amounts
                    //until it is made up for
                    var total_adjust = inlist[0].original_amount - inlist[0].amount;
                    for(var i=0; i<plan.length; i++) {
                        if(plan[i].bid_mark_up <= total_adjust) {
                            total_adjust -= plan[i].bid_mark_up;
                            plan[i].bid_mark_up = 0;
                        } else {
                            plan[i].bid_mark_up -= total_adjust;
                            total_adjust = 0;
                            break;
                        }
                    }

                    plan.bid_mark_up = inlist[0].amount;
                    plan.bid_total -= inlist[0].original_amount - inlist[0].amount;
                }

                inlist = $filter('filter')(trade.extra_liability, 
                    {'plan_code': plan.plan_code}, true);
                if(inlist.length === 1) {
                    plan.bid_general_liability += inlist[0].amount;
                    //$scope.bid_total += inlist[0].amount;
                    plan.bid_total = plan.bid_total_labor + plan.bid_total_materials +
                        plan.bid_total_equipment + plan.bid_general_liability + plan.bid_mark_up;
                }

                _.each(plan, function(item) {
                    item.trade_code = trade.trade_code,
                    item.company_code = trade.company_code
                });

                plan_total = plan_total + plan.bid_total;
                $scope.totals.push({
                    trade: trade.trade,
                    trade_code: trade.trade_code,
                    company_code: trade.company_code,
                    name: trade.name,
                    plan: plan.plan_code,
                    total: plan.bid_total,
                    bid_total_hours_allowed: plan.bid_total_hours_allowed,
                    bid_avg_crew_rate: plan.bid_direct_labor / plan.bid_total_hours_allowed,
                    bid_direct_labor: plan.bid_direct_labor,
                    bid_total_labor: plan.bid_total_labor,
                    bid_workers_comp: plan.bid_workers_comp,
                    bid_total_materials: plan.bid_total_materials,
                    bid_total_equipment: plan.bid_total_equipment,
                    bid_general_liability: plan.bid_general_liability,
                    bid_mark_up: plan.bid_mark_up,
                    tasks: plan
                });

                $scope.matrix_totals.push({
                    trade: trade.trade,
                    trade_code: trade.trade_code,
                    company_code: trade.company_code,
                    name: trade.name,
                    plan: plan.plan_code,
                    total: plan.bid_total
                });

                plan.forEach(function(item) {
                    var inlist = $filter('filter')($scope.global_task_list, 
                        { 'task_name': item.name, 'plan': plan.plan_code }, true);

                    if(inlist.length === 0) {
                        _.each(item.subtasks, function(sub) {
                            sub.trade_code = trade.trade_code;
                            sub.company_code = trade.company_code;
                        });

                        var new_copy = angular.copy(item);
                        new_copy.average_crew_pay = 
                            new_copy.current_net_pay_subtotal / new_copy.total_hours_allowed;

                        $scope.global_task_list.push({
                            task_name: new_copy.name,
                            trade_name: trade.name,
                            trade: trade.trade,
                            trade_code: trade.trade_code,
                            company_code: trade.company_code,
                            plan: item.plan,
                            values: [new_copy]
                        });
                    } else {
                        _.each(item.subtasks, function(sub) {
                            sub.trade_code = trade.trade_code;
                            sub.company_code = trade.company_code;
                            var sublist = $filter('filter')(inlist[0].values[0].subtasks,
                                { 'name': sub.name}, true);

                            if(sublist.length === 0) {
                                var new_copy = angular.copy(sub);
                                inlist[0].values[0].subtasks.push(sub);
                            } else {
                                //sublist[0].values.push(sub);
                            }
                        });
                        
                        item.trade_code = trade.trade_code;
                        item.company_code = trade.company_code;
                        item.average_crew_pay = 
                            item.current_net_pay_subtotal / item.total_hours_allowed;
                        inlist[0].values.push(item);
                    }
                });
            });
            trade.plan_total = plan_total;
        });
    };

    $scope.transformTotalsArray = function(dataArray) {
        //console.log(dataArray);
        var trades = [];
        var plans = [];
        var ret_val = [];
        var row = [];

        $scope.global_plan_tasks = [];

        for(var i=0; i<dataArray.length; i++) {
            var trade = $filter('filter')(trades, {'name': dataArray[i].name}, true);
            var plan = $filter('filter')(plans, {'plan': dataArray[i].plan}, true);

            if(trade.length === 0) trades.push({'name': dataArray[i].name});
            if(plan.length === 0) plans.push({'plan': dataArray[i].plan});
        }

        for(var i=0; i<plans.length; i++) {
            row = [];
            for(var j=0; j<trades.length; j++) {
                var item = $filter('filter')(dataArray, {'plan': plans[i].plan, 'name': trades[j].name}, true)[0];
                row.push(item);
                for(var k=0; k<item.tasks.length; k++){
                    $scope.global_plan_tasks.push({
                        tasks: item.tasks[k],
                        name: item.name,
                        plan: item.plan,
                        trade: item.trade
                    });
                }
            }
            ret_val.push(row);
        }

        console.log(ret_val);

        return ret_val;
    };

    $scope.getPivotArray = function(dataArray, rowIndex, colIndex, dataIndex) {
        //Code from http://techbrij.com
        var result = {}, ret = [];
        var newCols = [];
        for (var i = 0; i < dataArray.length; i++) {
 
            if (!result[dataArray[i][rowIndex]]) {
                result[dataArray[i][rowIndex]] = {};
            }
            result[dataArray[i][rowIndex]][dataArray[i][colIndex]] = dataArray[i][dataIndex];
 
            //To get column names
            if (newCols.indexOf(dataArray[i][colIndex]) == -1) {
                newCols.push(dataArray[i][colIndex]);
            }
        }
 
        newCols.sort();
        var item = [];
 
        //Add Header Row
        item.push('Item');
        item.push.apply(item, newCols);
        ret.push(item);
 
        //Add content 
        for (var key in result) {
            item = [];
            item.push(key);
            for (var i = 0; i < newCols.length; i++) {
                item.push(result[key][newCols[i]] || "-");
            }
            ret.push(item);
        }
        return ret;
    }

    $scope.getPlanTotals = function(item) {
        var temp = $filter('filter')($scope.totals, {plan: item}, true);
        var ret_val = 0;
        temp.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.getTradeTotals = function(item) {
        var temp = $filter('filter')($scope.totals, {trade: item}, true);
        var ret_val = 0;
        temp.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.getAllTotals = function() {
        var ret_val = 0;
        $scope.totals.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.updateTablePlan = function() {
        $scope.bid_tasks = [];
        var current_bid_trade = [];

        var bid_trade = $scope.bid.bidding_trades[$scope.current_bid_index];
        
        var bids = $filter('filter')(bid_trade.bid, {'plan_code': $scope.current_plan.item}, true);
        var task_list = $scope.bid.bidding_trades[$scope.current_bid_index].task_list;

        //first build a task_list that only has the current bid trade
        bids.forEach(function(bid_task) {
            var task = $filter('filter')(task_list, {_id: bid_task.task_id}, true);

            if(task.length !== 1) {
                console.log('There is more than one task with the task id requested ' + bid_task.task_id);
                return;
            }

            task[0].plan_code = bid_task.plan_code;

            bid_task.subtasks.forEach(function(subtask, si) {
                task[0].subtasks.forEach(function(tsub, tsi) {
                    if(subtask.task_id === tsub._id) {
                        tsub.quantity = subtask.quantity;
                        tsub.bid_hours = subtask.bid_hours;
                        tsub.labor = subtask.labor;
                    }
                });

                subtask.equipment.forEach(function(eq, eidx) {
                    task[0].subtasks[si].equipment.forEach(function(teq, teidx) {
                        if(eq.equipment_id === teq._id) {
                            teq.quantity = eq.quantity;
                            if(eq.price_per_order)
                              teq.price_per_order = eq.price_per_order;
                            if(eq.delivery_price)
                              teq.delivery_price = eq.delivery_price;
                        }
                    });
                });
                subtask.materials.forEach(function(mq, midx) {
                    task[0].subtasks[si].materials.forEach(function(tmq, tmidx) {
                        if(mq.material_id === tmq._id && tmq._id) {
                            tmq.quantity = mq.quantity;
                            if(mq.price_per_order)
                              tmq.price_per_order = mq.price_per_order;
                            if(mq.delivery_price)
                              tmq.delivery_price = mq.delivery_price;
                        }
                    });
                });
            });

            $scope.bid_tasks.push(task[0]);
        });

        $scope.applayCalculations($scope.bid_tasks, bid_trade.name);
        $scope.bid_avg_crew_rate = $scope.bid_total_labor / $scope.bid_total_hours_allowed;

        if(!bid_trade.company_code)
          bid_trade.company_code = userService.getCompanyCode(bid_trade.username);

        if(!bid_trade.trade_code)
          bid_trade.trade_code = userService.getTradeCode(bid_trade.username);

        if(!$scope.shouldDisplayItem(bid_trade, 'crew_rate')) {
            $scope.bid_avg_crew_rate = 'N/A';
            _.each($scope.bid_tasks, function(task) {
                _.each(task.subtasks, function(subtask) {
                    subtask.crew_rate = 'N/A';
                });
            });
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'equipment_costs')) {
            $scope.bid_tasks.bid_equipment_subtotal = 'N/A';
            $scope.bid_tasks.bid_equipment_taxes = 'N/A';
            $scope.bid_tasks.bid_total_equipment = 'N/A';
            $scope.bid_equipment_subtotal = 'N/A';
            $scope.bid_equipment_taxes = 'N/A';
            $scope.bid_total_equipment = 'N/A';
            _.each($scope.bid_tasks, function(task) {
                task.equipment_dev_subtotal = 'N/A';
                task.equipment_subtotal = 'N/A';
                task.total_equipment = 'N/A';
                _.each(task.subtasks, function(subtask) {
                    subtask.equipment_dev_subtotal = 'N/A';
                    subtask.equipment_subtotal = 'N/A';
                    subtask.equipment_total = 'N/A';
                });
            });
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'hours_allowed')) {
            $scope.bid_tasks.bid_total_hours_allowed = 'N/A';
            $scope.bid_total_hours_allowed = 'N/A';
            _.each($scope.bid_tasks, function(task) {
                task.hours_allowed_subtotal = 'N/A';
                task.total_hours_allowed = 'N/A';
                _.each(task.subtasks, function(subtask) {
                    subtask.hours_allowed = 'N/A';
                });
            });
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'labor_costs')) {
            $scope.bid_tasks.bid_total_labor = 'N/A';
            $scope.bid_total_labor = 'N/A';
            _.each($scope.bid_tasks, function(task) {
                task.total_labor = 'N/A';
                _.each(task.subtasks, function(subtask) {
                    subtask.labor = 'N/A';
                });
            });
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'liability')) {
            $scope.bid_tasks.bid_general_liability = 'N/A';
            $scope.bid_general_liability = 'N/A';
            _.each($scope.bid_tasks, function(task) {
                task.bid_general_liability = 'N/A';
                _.each(task.subtasks, function(subtask) {
                    subtask.general_liability = 'N/A';
                });
            });
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'markup')) {
            $scope.bid_tasks.bid_mark_up = 'N/A';
            $scope.bid_mark_up = 'N/A';
            _.each($scope.bid_tasks, function(task) {
                task.bid_mark_up = 'N/A';
                _.each(task.subtasks, function(subtask) {
                    subtask.bid_mark_up = 'N/A';
                });
            });
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'material_costs')) {
            $scope.bid_tasks.bid_materials_subtotal = 'N/A';
            $scope.bid_tasks.bid_materials_taxes = 'N/A';
            $scope.bid_tasks.bid_total_materials = 'N/A';
            $scope.bid_materials_subtotal = 'N/A';
            $scope.bid_materials_taxes = 'N/A';
            $scope.bid_total_materials = 'N/A';
            _.each($scope.bid_tasks, function(task) {
                task.materials_dev_subtotal = 'N/A';
                task.materials_subtotal = 'N/A';
                task.total_materials = 'N/A';
                _.each(task.subtasks, function(subtask) {
                    subtask.materials_dev_subtotal = 'N/A';
                    subtask.materials_subtotal = 'N/A';
                    subtask.materials_total = 'N/A';
                });
            });
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'trade_rates')) {
            
        }
        if(!$scope.shouldDisplayItem(bid_trade, 'quantity')) {
            _.each($scope.bid_tasks, function(task) {
                _.each(task.subtasks, function(subtask) {
                    subtask.quantity = 'N/A';
                    _.each(subtask.materials, function(mat) {
                        mat.quantity = 'N/A';
                        mat.quantity_allowed = 'N/A';
                    });
                    _.each(subtask.equipment, function(eq) {
                        eq.quantity = 'N/A';
                        eq.quantity_allowed = 'N/A';
                    });
                });
            });
        }
    };

    $scope.onSelect = function(trade) {
        if(trade === 'Total') {
            $scope.current_trade_selection = {};
            $scope.current_trade_selection.trade = 'Total';
            return;
        }

        var item = $filter('filter')($scope.trade_totals, {'name': trade}, true);
        var index = $scope.trade_totals.indexOf(item[0]);
        
        var trade_bid = $scope.trade_totals[index];

        $scope.current_bid_index = index;

        $scope.materialsPage(trade_bid);

        $scope.current_trade_selection = trade_bid;
        $scope.updateSpecs();
        $scope.updateTablePlan();
        //$scope.updateQuantity(0);
    };

    $scope.updateSpecs = function() {
        $scope.specs = [];

        var bid = $scope.bid.bidding_trades[$scope.current_bid_index];

        $scope.specs.push({
            trade: bid.name,
            inclusions: bid.inclusions,
            exclusions: bid.exclusions
        });
    };

    $scope.onPlanSelect = function(item) {
        console.log('in the onSelect function ' + item.item);
        $scope.current_plan = item;

        var bid = $scope.bid.bidding_trades[$scope.current_bid_index];

        $scope.materials = 
            bidRequestEditService.getMaterials(bid.bid, bid.task_list);

        _.each($scope.materials, function(mat) {
            mat.total = mat.quantity * mat.price_per_order;
        });

        var bid_total = $scope.bid.bidding_trades[$scope.current_bid_index];

        if(!$scope.shouldDisplayItem(bid_total, 'quantity')) {
            _.each($scope.materials, function(mat) {
                mat.quantity = 'N/A';
                mat.quantity_allowed = 'N/A';
            });
        }

        $scope.updateTablePlan();
    };
    
    $scope.viewBidBuilderDetails = function(index) {
        $location.path('builder/details');
    };

    $scope.applayCalculations = function(tasks, trade) {
        var costs = $filter('filter')($scope.bid.bidding_trades, {'name': trade}, true);
        //taskTotalsService.getTradeCalculations(tasks, trade, $scope.bid.costs);
        if(costs[0].submitted === 'true') {
            taskTotalsService.getCalculations(tasks, costs[0].costs);

            $scope.bid_total = tasks.bid_total;
            $scope.bid_general_liability = tasks.bid_general_liability;
            $scope.bid_total_labor = tasks.bid_total_labor;
            $scope.bid_total_materials = tasks.bid_total_materials;
            $scope.bid_materials_taxes = tasks.bid_materials_taxes;
            $scope.bid_materials_subtotal = tasks.bid_materials_subtotal;
            $scope.bid_total_equipment = tasks.bid_total_equipment;
            $scope.bid_equipment_subtotal = tasks.bid_equipment_subtotal;
            $scope.bid_equipment_taxes = tasks.bid_equipment_taxes;
            $scope.bid_direct_labor = tasks.bid_direct_labor;
            $scope.bid_mark_up = tasks.bid_mark_up;
            $scope.bid_workers_comp = tasks.bid_workers_comp;
            $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;
            $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
            $scope.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
            $scope.bid_direct_labor = tasks.bid_direct_labor;
            $scope.bid_workers_comp = tasks.bid_workers_comp;
            $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;

            var inlist = $filter('filter')(costs[0].overrides, 
                {'plan_code': $scope.current_plan.item}, true);

            if(inlist.length === 0) {
              $scope.bid_mark_up = tasks.bid_mark_up;
              $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
            } else if(inlist.length === 1) {
                //so...we have an override here and need to adjust
                //the tasks that make up this plan to remove the amounts
                //until it is made up for
                var total_adjust = inlist[0].original_amount - inlist[0].amount;
                for(var i=0; i<tasks.length; i++) {
                    if(tasks[i].bid_mark_up <= total_adjust) {
                        total_adjust -= tasks[i].bid_mark_up;
                        tasks[i].bid_mark_up = 0;
                    } else {
                        tasks[i].bid_mark_up -= total_adjust;
                        total_adjust = 0;
                        break;
                    }
                }

                $scope.bid_mark_up = inlist[0].amount;
                $scope.bid_overhead_and_profit = inlist[0].amount;
                $scope.bid_total -= inlist[0].original_amount - inlist[0].amount;
            }

            inlist = $filter('filter')(costs[0].extra_liability,
                {'plan_code': $scope.current_plan.item}, true);

            if(inlist.length === 1) {
                $scope.bid_general_liability += inlist[0].amount;
                //$scope.bid_total += inlist[0].amount;
                $scope.bid_total = $scope.bid_total_labor + $scope.bid_total_materials +
                    $scope.bid_total_equipment + $scope.bid_general_liability + $scope.bid_mark_up;
            }
        } else {
            $scope.bid_total = 0;
            $scope.bid_general_liability = 0
            $scope.bid_total_labor = 0;
            $scope.bid_total_materials = 0;
            $scope.bid_materials_taxes = 0;
            $scope.bid_materials_subtotal = 0;
            $scope.bid_total_equipment = 0;
            $scope.bid_equipment_subtotal = 0;
            $scope.bid_equipment_taxes = 0;
            $scope.bid_direct_labor = 0;
            $scope.bid_mark_up = 0;
            $scope.bid_workers_comp = 0;
            $scope.bid_payroll_taxes = 0;
            $scope.bid_overhead_and_profit = 0;
            $scope.bid_total_hours_allowed = 0;
            $scope.bid_direct_labor = 0;
            $scope.bid_workers_comp = 0;
            $scope.bid_payroll_taxes = 0;
        }
    };

    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.setShowPlanDetails =  function(val) {
        $scope.open_plan_details = val;
    };

    $scope.setShowRatesDetails =  function(val) {
        $scope.open_rates_details = val;
    };

    $scope.setShowTaskDetails =  function(val) {
        $scope.open_task_details = val;
    };

    $scope.showEvenMoreDetails = function(index) {
        if($scope.showSubtaskExtremeDetails === index)
            $scope.showSubtaskExtremeDetails = -1;
        else 
            $scope.showSubtaskExtremeDetails = index;
    };

    $scope.setShowSubtaskDetails =  function(index) {
        if($scope.showSubtaskDetails === index)
            $scope.showSubtaskDetails = -1;
        else 
            $scope.showSubtaskDetails = index;
    };

    $scope.setShowExpandableDetails =  function(pid) {
        $scope.selectedPlan = $scope.plan_total_items[pid].item;
        $scope.open_task_details = $scope.open_plan_details = false;
        $scope.showSubtaskDetails = -1;

        if($scope.showExpandableDetails === pid)
            $scope.showExpandableDetails = -1;
        else
            $scope.showExpandableDetails = pid;
    };

    $scope.getSubtaskTotal = function(name, plan, trade_name, idx) {
        var totals = $filter('filter')($scope.trade_totals, {'name': trade_name}, true);
        var tasks = [];//$filter('filter')(totals[0].plan_totals, {'plan_code': plan}, true);
        for(var i=0; i<totals[0].plan_totals.length; i++) {
            if(totals[0].plan_totals[i].plan_code === plan) {
                tasks = totals[0].plan_totals[i];
                break;
            }
        }

        tasks = $filter('filter')(tasks, {'task': name.task}, true);
        
        if(tasks.length !== 1) {
            toaster.pop('error', 'Task Loading Error', 'Contact Admin');
            return;
        }

        var sub = $filter('filter')(tasks[0].subtasks, {'_id': name._id, 'name': name.name}, true);

        if(sub.length !== 1) {
            //toaster.pop('error', 'Subtask Loading Error', 'Contact Admin');
            return 0;
        }

        return sub[0];
    };

    $scope.getSubtask = function(name, plan, trade_name, idx) {
        var totals = $filter('filter')($scope.trade_totals, {'name': trade_name}, true);
        var tasks = [];//$filter('filter')(totals[0].plan_totals, {'plan_code': plan}, true);
        for(var i=0; i<totals[0].plan_totals.length; i++) {
            if(totals[0].plan_totals[i].plan_code === plan) {
                tasks = totals[0].plan_totals[i];
                break;
            }
        }

        tasks = $filter('filter')(tasks, {'task': name.task}, true);
        
        if(tasks.length !== 1) {
            toaster.pop('error', 'Task Loading Error', 'Contact Admin');
            return;
        }

        var sub = $filter('filter')(tasks[0].subtasks, {'_id': name._id}, true);

        if(sub.length !== 1) {
            //toaster.pop('error', 'Subtask Loading Error', 'Contact Admin');
            return;
        }

        return sub[0];
    };

    $scope.getRates = function(name) {
        var trade = $filter('filter')($scope.bid.bidding_trades, {'name': name}, true);
        if(trade.length !== 1) {
            toaster.pop('error', 'Trade Error', 'Cannot get trade rates.');
            return;
        }

        if(!trade[0].company_code)
          trade[0].company_code = userService.getCompanyCode(trade[0].username);

        if(!trade[0].trade_code)
          trade[0].trade_code = userService.getTradeCode(trade[0].username);

        if($scope.shouldDisplayItem(trade[0], 'trade_rates'))
          return trade[0].costs;
        else
          return 'N/A';
    };

    $scope.updateQuantity = function(index) {
        if(!$scope.plan_total_items) return;

        $scope.total_quantity = 0;
        $scope.sub_total_bidding_trades = [];
        $scope.plan_total_items.forEach(function(total, itotal) {
            if(!angular.isUndefined(total.quantity)) {
                $scope.total_quantity += total.quantity;
                var totals = $filter('filter')($scope.matrix_totals, {'plan': total.item}, true);

                totals.forEach(function(item) {
                    var idx = $scope.sub_bidding_trades.indexOf(item.name);

                    if(idx !== -1) {
                        if(itotal === 0) {
                            $scope.sub_total_bidding_trades[idx] = {
                                total: item.total * total.quantity
                            };
                        } else {
                            $scope.sub_total_bidding_trades[idx].total += item.total * total.quantity;
                        }
                    }
                });
            }
        });
    };

    $scope.checkAllTradesSelected = function() {
        var all_trades = [];

        if($scope.is_builder) {
            for(var i=0; i<$scope.bid.bidding_trades.length; i++) {
                var inlist = $filter('filter')(all_trades, 
                    {'trade': $scope.bid.bidding_trades[i].trade}, true);
                var trades = $filter('filter')($scope.bid.bidding_trades, 
                    {'trade': $scope.bid.bidding_trades[i].trade}, true);

                if(inlist.length === 0) {
                    all_trades.push({
                        'trade': $scope.bid.bidding_trades[i].trade,
                        'accepted': false
                    });
                    for(var j=0; j<trades.length; j++) {
                        if(trades[j].accepted) {
                            all_trades[all_trades.length-1].accepted = true;
                            all_trades[all_trades.length-1].date_accepted = new Date();
                        }
                    }
                } else if(inlist.length === 1) {
                    if(!inlist[0].accepted) {
                        for(var j=0; j<trades.length; j++) {
                            if(trades[j].accepted) {
                                inlist[0].accepted = true;
                                inlist[0].date_accepted = new Date();
                            }
                        }
                    }
                }
            }

            var test = true;
            for(var i=0; i<all_trades.length; i++) {
                if(all_trades[i].accepted === false)
                  test = false;
            }

            return $scope.allTradesSelected = test;
        } else {
            //this is a trade bid and there is no reason to do
            //the select winning bid process so set the accepted
            //field in the database so the bid will be processed
            if(!$scope.bid.in_bidder_revision) {
                TradeBids.query({
                    '_id': $scope.bid.bidding_trades[0]._id }, function(bid) {
                    bid[0].accepted = true;
                    bid[0].date_accepted = new Date();
                    bid[0].$update();
                });
            }

            return $scope.allTradesSelected = true;
        }
    };

    $scope.checkCurrentTradeSelected = function() {
        var trades = $filter('filter')($scope.bid.bidding_trades, {
            'trade': $scope.selectedTrade}, true);

        for(var i=0; i<trades.length; i++) {
            if(trades[i].accepted) {
                $scope.currentTradeSelected = true;
                // $scope.selectedTradeBid = trades[i];
            }
        }

        if($scope.checkAllTradesSelected()) {
            console.log('all trades are selected');
        }
    };

    $scope.clearIfSelected = function() {
        $scope.selectedWinner.accepted = true;
        var trades = $filter('filter')($scope.bid.bidding_trades, {
            'trade': $scope.selectedTrade}, true);

        var found = false;
        for(var i=0; i<trades.length; i++) {
            //there should be one at most for a given trade
            if(trades[i].accepted) {
                found = true;

                TradeBids.query({'_id': trades[i]._id}, function(bid) {
                    bid[0].accepted = true;
                    bid[0].date_accepted = new Date();
                    bid[0].rejected = false;
                    bid[0].$update(function(result) {
                        $scope.selectWinningBid();
                    });
                });
            } else {
                TradeBids.query({'_id': trades[i]._id}, function(bid) {
                    bid[0].accepted = false;
                    bid[0].rejected = true;
                    bid[0].date_rejected = new Date();
                    bid[0].$update(function(result) {
                        $scope.selectWinningBid();
                    });
                });
            }
        }

        if(!found) {
            $scope.selectWinningBid();
        }
    }

    $scope.selectWinningBid = function() {
        TradeBids.query({'_id': $scope.selectedWinner._id}, function(bid) {
            if(bid.length !== 1) {
                toaster.pop('error', 'Trade Bid Database', 'Problem getting bid from the database');
                return;
            }

            bid[0].accepted = true;
            bid[0].date_accepted = new Date();

            bid[0].$update(function(result) {
                $scope.checkCurrentTradeSelected();
                toaster.pop('success', 'Trade Bid Database', 'Database updated');
            }, function(error) {
                toaster.pop('error', 'Trade Bid Database', 'Problem updating the database');
            });
        });
    };

    $scope.submitBid = function() {
        // given this is also used for trades to review a bid and
        // submit, we need to get the trade code and then accept
        var code = tradeCodeService.getCode($scope.user.trade[0]);

        $scope.bid.bidding_trades = $filter('filter')($scope.bid.bidding_trades, {
            'remove': false }, true);
        
        console.log('need to figure if revision or not');
        if($scope.bid.in_bidder_revision) {
            bidService.acceptRevisedBid(
                $scope.bid, 
                code, 
                builderService.isBuilder($scope.user.username),
                $scope.totals);
        } else {
            bidService.acceptBid(
                $scope.main_account_id,
                $scope.bid,
                code, 
                builderService.isBuilder($scope.user.username),
                $scope.totals
                );
        }

        $location.path('/');
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/builders/public/controllers/builderReview.js